import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  blocksShipping: {
    defaultMessage: 'BLOCKS SHIPPING',
    id: 'px3IBQ',
    description: 'Label indicating this rule blocks shipping',
  },
  flagsForReview: {
    defaultMessage: 'FLAGS FOR REVIEW (does not block)',
    id: '89zFSk',
    description: 'Label indicating this rule flags orders for review',
  },
  informationalOnly: {
    defaultMessage: 'INFORMATIONAL ONLY (does not block)',
    id: 'F3NRID',
    description: 'Label indicating this rule is informational only',
  },
  toggleOn: {
    defaultMessage: 'ON',
    id: 'iO3uVx',
    description: 'Label for toggle when feature is enabled',
  },
  toggleOff: {
    defaultMessage: 'OFF',
    id: '/YQLqS',
    description: 'Label for toggle when feature is disabled',
  },
});
